class AssemblyGuideController {
  constructor(root, data) {
    this.root = root;

    this.data = data || {};
    this.language = Array.isArray(this.data.language) ? this.data.language : [];
    this.seriesList = Array.isArray(this.data.series) ? this.data.series : [];
    this.productsList = Array.isArray(this.data.products) ? this.data.products : [];

    this.langSelect = this.root.querySelector('#ag-lang');
    this.seriesWrap = this.root.querySelector('[data-ag-series-wrap]');
    this.seriesSelect = this.root.querySelector('#ag-series');
    this.productWrap = this.root.querySelector('[data-ag-product-wrap]');
    this.productSelect = this.root.querySelector('#ag-product');
    this.result = this.root.querySelector('[data-ag-result]');

    this.technicalPdfBoxWrap = this.root.querySelector('.technical-pdf');
    this.userManualBoxWrap = this.root.querySelector('.user-manual');
    this.assemblyGuideBoxWrap = this.root.querySelector('.assembly-guide');
    this.assemblyVideoBoxWrap = this.root.querySelector('.assembly-video');
    
    this.technicalPdfBox = this.root.querySelector('[data-technical-pdf]');
    this.technicalPdfImgBox = this.root.querySelector('[data-technical-pdf-img]');
    this.userManualBox = this.root.querySelector('[data-user-manual]');
    this.userManualImgBox = this.root.querySelector('[data-user-manual-img]');
    this.assemblyGuideBox = this.root.querySelector('[data-assembly-guide]');
    this.assemblyGuideImgBox = this.root.querySelector('[data-assembly-guide-img]');
    this.assemblyVideoBox = this.root.querySelector('[data-assembly-video]');
    this.assemblyVideoImgBox = this.root.querySelector('[data-assembly-video-img]');

    // About label
    this.headerTitleEle = this.root.querySelector('.ag-title');
    this.languageLabelEle = this.root.querySelector('.language-label');
    this.seriesLabelEle = this.root.querySelector('.series-label');
    this.productLabelEle = this.root.querySelector('.product-label');

    // Technical Asset Elements
    this.technicalThumbnailEle = this.root.querySelector('.technical-thumbnail');
    this.technicalThumbnailTitleEle = this.root.querySelector('.technical-title');
    this.technicalThumbnailLinkEle = this.root.querySelector('.technical-link');

    // User Manual Elements
    this.userManualThumbnailEle = this.root.querySelector('.user-manual-thumbnail');
    this.userManualTitleEle = this.root.querySelector('.user-manual-title');
    this.userManualLinkEle = this.root.querySelector('.user-manual-link');

    // Assembly Guide Elements
    this.assemblyGuideThumbnailEle = this.root.querySelector('.assembly-guide-thumbnail');
    this.assemblyGuideTitleEle = this.root.querySelector('.assembly-guide-title');
    this.assemblyGuideLinkEle = this.root.querySelector('.assembly-guide-link');

    // Assembly Video Asset Elements
    this.assemblyVideoThumbnailEle = this.root.querySelector('.assembly-video-thumbnail');
    this.assemblyVideoTitleEle = this.root.querySelector('.assembly-video-title');
    this.assemblyVideoLinkEle = this.root.querySelector('.assembly-video-link');
  }
  
  init() {
    if (!this.langSelect || !this.seriesWrap || !this.seriesSelect || !this.productWrap || !this.productSelect || !this.result) return;

    this.renderLanguage();
    this.seriesWrap.hidden = true;
    this.productWrap.hidden = true;
    this.result.hidden = true;

    // Defaults: lang=en first, series first, product first.
    this.initDefaults();
    this.bindEvents();
  }

  initDefaults() {
    const lang = this.ensureDefaultLanguage();
    if (!lang) return;

    this.setPageText(lang);

    this.renderSeries(lang);
    const seriesId = this.selectFirstNonEmptyOption(this.seriesSelect);
    if (!seriesId) return;

    this.renderProducts(lang, seriesId);
    const productId = this.selectFirstNonEmptyOption(this.productSelect);
    if (!productId) return;

    this.renderAssets(lang, productId);
  }

  bindEvents() {
    this.langSelect.addEventListener('change', () => {
      const lang = this.langSelect.value;
      if (lang) {
        window.localStorage.setItem('ag_selected_language', lang);
      }
      
      this.setPageText(lang);

      this.seriesWrap.hidden = true;
      this.productWrap.hidden = true;
      this.result.hidden = true;

      this.resetSelect(this.seriesSelect, 'Select series');
      this.resetSelect(this.productSelect, 'Select product');

      if (!lang) return;
      this.renderSeries(lang);

      const seriesId = this.selectFirstNonEmptyOption(this.seriesSelect);
      if (!seriesId) return;
      this.renderProducts(lang, seriesId);

      const productId = this.selectFirstNonEmptyOption(this.productSelect);
      if (!productId) return;
      this.renderAssets(lang, productId);
    });

    this.seriesSelect.addEventListener('change', () => {
      const lang = this.langSelect.value;
      const seriesId = this.seriesSelect.value;
      this.productWrap.hidden = true;
      this.result.hidden = true;

      this.resetSelect(this.productSelect, 'Select product');
      if (!lang || !seriesId) return;
      this.renderProducts(lang, seriesId);

      const productId = this.selectFirstNonEmptyOption(this.productSelect);
      if (!productId) return;
      this.renderAssets(lang, productId);
    });

    this.productSelect.addEventListener('change', () => {
      const lang = this.langSelect.value;
      const productId = this.productSelect.value;
      if (!productId) { this.result.hidden = true; return; }
      this.renderAssets(lang, productId);
    });
  }

  // 创建select 下的 option
  opt(value, label) {
    let o = document.createElement('option');
    o.value = value;
    o.textContent = label;
    return o;
  }

  // 获取label标签
  getLabel(obj, lang) {
    if (!obj) return '';
    let labels = obj.labels || {};
    return labels[lang];
  }

  resetSelect(sel, placeholder) {
    sel.innerHTML = '';
    // sel.appendChild(opt('', placeholder));
    sel.value = '';
  }

  // set page context
  setPageText(langSelect) {
    const languageItem = this.language.filter(land => {
      return land.code === langSelect;
    });
    
    const {
      title,
      label_lang,
      label_series,
      label_product,

      technical_img,
      technical_title,
      technical_download_text,

      user_manual_img,
      user_manual_title,
      user_manual_text,

      assembly_guide_img,
      assembly_guide_title,
      assembly_guide_text,

      assembly_video_img,
      assembly_video_title,
      assembly_video_text
    } = languageItem[0].other;

    // Init Image
    this.technicalThumbnailEle.src = '';
    this.userManualThumbnailEle.src = '';
    this.assemblyGuideThumbnailEle.src = '';
    this.assemblyVideoThumbnailEle.src = '';
    
    this.headerTitleEle.innerHTML = title;
    this.languageLabelEle.innerHTML = label_lang;
    this.seriesLabelEle.innerHTML = label_series;
    this.productLabelEle.innerHTML = label_product;

    // Technical Text
    this.technicalThumbnailEle.src = technical_img;
    this.technicalThumbnailTitleEle.textContent = technical_title;
    this.technicalThumbnailLinkEle.textContent = technical_download_text;

    // User Manual Text
    this.userManualThumbnailEle.src = user_manual_img;
    this.userManualTitleEle.textContent = user_manual_title;
    this.userManualLinkEle.textContent = user_manual_text;

    // Assembly Guide Text
    this.assemblyGuideThumbnailEle.src = assembly_guide_img;
    this.assemblyGuideTitleEle.textContent = assembly_guide_title;
    this.assemblyGuideLinkEle.textContent = assembly_guide_text;

    // Assembly Text
    this.assemblyVideoThumbnailEle.src = assembly_video_img;
    this.assemblyVideoTitleEle.textContent = assembly_video_title;
    this.assemblyVideoLinkEle.textContent = assembly_video_text;
  }

  // 给language select options 添加值
  renderLanguage() {
    this.resetSelect(this.langSelect, 'Select language');
    for (let i = 0; i < this.language.length; i++) {
      this.langSelect.appendChild(this.opt(this.language[i].code, this.language[i].label));
    }
  }

  // 给series select options 添加值
  renderSeries(lang) {
    this.resetSelect(this.seriesSelect, 'Select series');
    for (let i = 0; i < this.seriesList.length; i++) {
      const label = this.getLabel(this.seriesList[i], lang);
      label && this.seriesSelect.appendChild(this.opt(this.seriesList[i].id, label));
    }
    this.seriesWrap.hidden = false;
  }

  // 给products select options 添加值
  renderProducts(lang, seriesId) {
    this.resetSelect(this.productSelect, 'Select product');
    for (let i = 0; i < this.productsList.length; i++) {
      if (this.productsList[i].series_id === seriesId) {
        const options = this.opt(this.productsList[i].id, this.getLabel(this.productsList[i], lang));
        options.textContent && this.productSelect.appendChild(options);
      }
    }
    this.productWrap.hidden = false;
  }

  // select 选项
  selectFirstNonEmptyOption(sel) {
    if (sel.options && sel.options.length) {
      sel.selectedIndex = 0;
      return sel.value;
    }
    sel.value = '';
    return '';
  }

  ensureDefaultLanguage() {
    const storageKey = 'ag_selected_language';
    let storedLang = '';
    try {
      storedLang = window.localStorage.getItem(storageKey);
    } catch (e) {
      storedLang = '';
    }

    if (storedLang) {
      for (let i = 0; i < this.langSelect.options.length; i++) {
        if (this.langSelect.options[i].value === storedLang) {
          this.langSelect.value = storedLang;
          return storedLang;
        }
      }
    }

    let hasEn = false;
    for (let i = 0; i < this.langSelect.options.length; i++) {
      if (this.langSelect.options[i].value === 'en') {
        hasEn = true;
        break;
      }
    }
    if (hasEn) {
      this.langSelect.value = 'en';
      window.localStorage.setItem(storageKey, 'en');

      return 'en';
    }

    const firstLang = this.selectFirstNonEmptyOption(this.langSelect);
    if (firstLang) {
      window.localStorage.setItem(storageKey, firstLang);
    }
    
    return firstLang;
  }

  // 根据语言获取对应产品的URL
  getAssetUrlByLang(asset, lang) {
    if (!asset) return '';
    let urls = asset.urls || {};
    return urls[lang] || '';
  }

  renderAssets(lang, productId) {
    let product = null;
    for (let i = 0; i < this.productsList.length; i++) {
      if (this.productsList[i].id === productId) {
        product = this.productsList[i];
        break;
      }
    }
    if (!product) {
      this.result.hidden = true;
      return;
    }

    let technicalPdfUrl = product.assets ? this.getAssetUrlByLang(product.assets['technical_pdf'], lang) : '';
    let userManualUrl = product.assets ? this.getAssetUrlByLang(product.assets['user_manual'], lang) : '';
    let assemblyGuidefUrl = product.assets ? this.getAssetUrlByLang(product.assets['assembly_guide'], lang) : '';
    let assemblyVideoUrl = product.assets ? this.getAssetUrlByLang(product.assets['assembly_video'], lang) : '';
    
    // TODO: Technical
    if (this.technicalPdfBox && technicalPdfUrl) {
      this.technicalPdfBoxWrap.hidden = false;
      this.technicalPdfBox.href =  technicalPdfUrl;
      this.technicalPdfImgBox.href =  technicalPdfUrl;
    } else {
      this.technicalPdfBoxWrap.hidden = true;
      this.technicalPdfBox.href =  '';
      this.technicalPdfImgBox.href =  '';
    };

    // TODO: User Manual
    if (this.userManualBox && userManualUrl) {
      this.userManualBoxWrap.hidden = false;
      this.userManualBox.href =  userManualUrl;
      this.userManualImgBox.href =  userManualUrl;
    } else {
      this.userManualBoxWrap.hidden = true;
      this.userManualBox.href =  '';
      this.userManualImgBox.href =  '';
    };

    // TODO: Assembly Guide
    if (this.assemblyGuideBox && assemblyGuidefUrl) {
      this.assemblyGuideBoxWrap.hidden = false;
      this.assemblyGuideBox.href =  assemblyGuidefUrl;
      this.assemblyGuideImgBox.href =  assemblyGuidefUrl;
    } else {
      this.assemblyGuideBoxWrap.hidden = true;
      this.assemblyGuideBox.href =  '';
      this.assemblyGuideImgBox.href =  '';
    };

    // TODO: Assembly
    if (this.assemblyVideoBox && assemblyVideoUrl) {
      this.assemblyVideoBoxWrap.hidden = false;
      this.assemblyVideoBox.href = assemblyVideoUrl;
      this.assemblyVideoImgBox.href = assemblyVideoUrl;
    } else {
      this.assemblyVideoBoxWrap.hidden = true;
      this.assemblyVideoBox.href = '';
      this.assemblyVideoImgBox.href = '';
    };

    this.result.hidden = false;
  }
}